<template>
  <div class="topForm upload">
    <vxe-toolbar size="mini" v-if="isEdit">
      <template v-slot:buttons>
        <vxe-button
          size="medium"
          type="primary"
          class="vxe-btn-delete"
          icon="el-icon-delete"
          @click="removeSelected()"
          >{{ $t('upload.delBtn') }}</vxe-button
        >
        <vxe-button
          size="medium"
          type="primary"
          class="vxe-btn-primary"
          icon="el-icon-download"
          @click="downLoadSelected()"
          >{{ $t('upload.downLoadBtn') }}</vxe-button
        >
        <vxe-button
          size="medium"
          type="primary"
          class="vxe-btn-primary"
          icon="el-icon-view"
          @click="viewContractFile()"
          >引用附件</vxe-button
        >
        <div class="uploadBtn">
          <el-upload
            class="upload-demo"
            :action="actionUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :data="{ access_token: userInfo.userInfo.access_token, path: filePath }"
            multiple
            :show-file-list="false"
            :on-exceed="handleExceed"
            :on-progress="handleProgress"
            :on-success="handleSuccess"
          >
            <vxe-button size="medium" type="primary" class="vxe-btn-save" icon="el-icon-upload">{{
              $t('upload.uploadBtn')
            }}</vxe-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      show-overflow
      resizable
      ref="xGrid"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :toolbar="tableToolbar"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @cell-dblclick="handleDblclick"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <!--<vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>-->
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/dataBase';
  //开发环境
  // import { devUrl } from '@/common/config/dev.env';
  //测试环境
  // import { testUrl } from '@/common/config/test.env';
  //正式环境
  // import { prodUrl } from '@/common/config/prod.env';
  import { dateTimeFormat } from '@/filters/index';
  import baseUrl from '@/common/config';
  export default {
    name: 'upload',
    props: {
      //是否显示上传和删除按钮
      isShow: {
        type: Boolean,
        default: () => true,
      },
      //默认值
      tableData: {
        type: Array,
        default: () => [],
      },
      defaultPath: {
        type: String,
        default: 'scm/maindata',
      },
      isEdit: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      let newDate = dateTimeFormat(new Date());
      return {
        uploadTableData: this.tableData,
        multipleSelection: [], //存放选中的值
        todayDate: newDate,
        actionUrl: '',
        show: this.isShow,
        filePath: this.defaultPath,
        tableToolbar: {
          id: 'toolbar',
          // refresh: true,
          // setting: {
          //   storage: true
          // }
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),

      //表格显示字段
      columnList() {
        return [
          {
            prop: 'attachmentName',
            label: this.$t('upload.attachmentName'),
            sortable: true,
          },
          { prop: 'createBy', label: this.$t('upload.uploader') },
          { prop: 'gmtCreate', label: this.$t('upload.uploadDate') },
        ];
      },
    },
    mounted() {
      /* // 线上环境配置axios.defaults.baseURL，生产环境则用proxy代理
    if (process.env.NODE_ENV === "production") {
      this.baseURL = prodUrl;
    } else if (process.env.NODE_ENV === "test") {
      this.baseURL = testUrl;
    } else {
      this.baseURL = devUrl;
    }
    this.actionUrl = this.baseURL + API.OSS_UPLOAD_API; */
      this.actionUrl = baseUrl + API.OSS_UPLOAD_API;
    },
    methods: {
      // 引用附件
      viewContractFile() {
        this.$emit('viewContractFile');
      },
      //返回数据
      getVal() {
        return JSON.stringify(this.tableData);
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          this.$t('salesBill.message.currentlyLimited') +
            files.length +
            this.$t('salesBill.message.allChooseFile') +
            files.length +
            fileList.length +
            this.$t('salesBill.message.file')
        );
      },
      beforeRemove(file) {
        return this.$confirm(
          this.$t('salesBill.message.sureRemove') +
            file.name +
            this.$t('salesBill.message.questionMark')
        );
      },
      // 上传时
      handleProgress(event, file, fileList) {
        console.log(event, file, fileList, '文件上传时');
        this.loading.startLoading('正在上传中....');
      },
      //上传成功
      handleSuccess(res, file) {
        this.loading.endLoading();
        if (res.code === 0) {
          let obj = {
            attachmentName: file.name,
            createBy: this.userInfo.userInfo.userName,
            gmtCreate: this.todayDate,
            attachmentPath: res.data.attachmentPath,
            attachmentKey: res.data.attachmentKey,
          };
          this.uploadTableData.push(obj);
          this.$refs.xGrid.reloadData(this.uploadTableData);
          this.$emit('upload', this.uploadTableData);
          //console.log(file,test)
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row.selection;
      },
      //删除
      removeSelected() {
        let _self = this;
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDel'),
            type: 'error',
          });
        } else {
          this.$confirmAction()
            .then(() => {
              this.$refs['xGrid'].removeSelecteds();
              this.uploadTableData = this.uploadTableData.filter((item) => {
                let flag = true;
                this.multipleSelection.map((select) => {
                  if (item._XID == select._XID) {
                    flag = false;
                  }
                });
                return flag;
              });
              //如果操作成功，直接返回列表
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              _self.$emit('upload', this.uploadTableData);
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //批量下载
      downLoadSelected() {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          let params = {
            keyList: this.multipleSelection.map((it) => it.attachmentKey),
          };
          this.$axios.post(API.DOWNLOAD_FILE, params).then((res) => {
            if (res.data.code == 0) {
              res.data.data.map((it) => {
                this.downloadFile(it);
              });
            }
          });
        }
      },
      //多个文件下载
      downloadFile(url) {
        window.open(url, '_blank');
      },
      //双击下载文档
      handleDblclick(data) {
        window.location.href = data.row.attachmentPath;
      },
    },
    watch: {
      tableData() {
        this.uploadTableData = this.tableData;
      },
      isShow() {
        this.show = this.isShow;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .uploadBtn {
    float: left;
    padding-right: 16px;
  }
</style>
